export default __webpack_public_path__ + "7ac0ca96af287e5498aab551650bd4f8.webp";